<template>
  <div class="vx-row justify-content-center mt-2 mb-2">
    <!-- RELEVANCY CIRCLE -->
    <div class="vx-col w-1/3">
      <div class="vx-row justify-content-center">
        <vue-circle
          :progress="relevancy"
          :size="80"
          :reverse="false"
          line-cap="round"
          :fill="fill"
          empty-fill="rgba(0, 0, 0, .1)"
          :animation-start-value="0.0"
          :start-angle="-Math.PI / 2"
          insert-mode="append"
          :thickness="10"
          :show-percent="true"
          @vue-circle-progress="progress_circle"
          @vue-circle-end="progress_end_circle">
        </vue-circle>
        <div class="w-full text-center">
          <span class="font-bold">{{ $t("components.progressMeasureChart.pmc1") }}</span>
        </div>
      </div>
    </div>

    <!-- PROGRESS CIRCLE -->
    <div class="vx-col w-1/3">
      <div class="vx-row justify-content-center">
        <vue-circle
          :progress="progress"
          :size="80"
          :reverse="false"
          line-cap="round"
          :fill="fill"
          empty-fill="rgba(0, 0, 0, .1)"
          :animation-start-value="0.0"
          :start-angle="-Math.PI / 2"
          insert-mode="append"
          :thickness="10"
          :show-percent="true"
          @vue-circle-progress="progress_circle"
          @vue-circle-end="progress_end_circle">
        </vue-circle>
        <div class="w-full text-center">
          <span class="font-bold">{{ $t("components.progressMeasureChart.pmc2") }}</span>
        </div>
      </div>
    </div>

    <!-- PRACTICE CIRCLE -->
    <div class="vx-col w-1/3">
      <div class="vx-row justify-content-center">
        <vue-circle
          :progress="practice"
          :size="80"
          :reverse="false"
          line-cap="round"
          :fill="fill"
          empty-fill="rgba(0, 0, 0, .1)"
          :animation-start-value="0.0"
          :start-angle="-Math.PI / 2"
          insert-mode="append"
          :thickness="10"
          :show-percent="true"
          @vue-circle-progress="progress_circle"
          @vue-circle-end="progress_end_circle">
        </vue-circle>
        <div class="w-full text-center">
          <span class="font-bold">{{ $t("components.progressMeasureChart.pmc3") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VueCircle from 'vue2-circle-progress/src/index.vue'

  export default {
    name: "ProgressMeasureChart",
    props: ["progress", "practice", "relevancy"],
    components: {
      VueCircle
    },
    methods: {
      progress_circle(event,progress,stepValue){
        console.log(stepValue);
      },
      progress_end_circle(event){
        console.log("Circle progress end");
      }
    },
    data() {
      return {
        fill: {gradient: ["#079E9A", "#76C488", "#9DCD5B"]},
        rel: [this.relevancy],
        prog: [this.progress],
        prac: [this.practice],
      }
    }
  };
</script>

<style scoped>
  .justify-content-center{
    justify-content: center;
  }
</style>